import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

export const PdfSignatureInstructions: React.FC = () => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '8px',
      paddingRight: 20,
      paddingLeft: 20,
      paddingBottom: 10
    },
    leftColumn: {
      flexDirection: 'row',
      paddingRight: 20,
      paddingLeft: 20
    },
    row: {
      width: '100%'
    },
    title: {
      textDecoration: 'underline',
      fontSize: '8px',
      paddingRight: 20,
      paddingLeft: 20,
      paddingTop: 10,
      fontFamily: "Libre Franklin Bold"
    }
  });

  return (
    <View>
      <Text style={[styles.text, {paddingBottom: 10, paddingTop: 10, fontSize: 9, lineHeight: 1.3}]}>
      The individual identified on this form has authorized ECFMG, a division of Intealth™, to contact your institution to request verification of the attached credential(s). Please complete the appropriate section of this verification form to certify whether you are able to confirm that this credential is authentic and correct, and return the completed form as well as the attached credential directly to ECFMG. If the above Names and/or Date of Birth do not match your records, please notify ECFMG at <Text style={{ color: '#5F9EA0', textDecoration: 'underline' }}>verifications@ecfmg.org</Text>.
      </Text>
    </View>
  );
};
export default PdfSignatureInstructions;
